(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9747],{

/***/ 7033:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip.396c7bfc.svg","height":30,"width":30});

/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Bundles_StaticBundle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/Bundles/localization.js
var localization = __webpack_require__(60303);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems/index.module.scss
var index_module = __webpack_require__(5777);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/cart/CartItemTile/analytics.js
var analytics = __webpack_require__(69162);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems/index.js














const BundleChildItems = (props)=>{
    var ref;
    const { data ={} , pdpView =false , page =""  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { colorOrFinish ="" , qty =0 , cannotShipLabel , outOfStockLabel  } = (0,localization/* getTranslations */.F)(t);
    const [productPdpUrl, setProductPdpUrl] = (0,react.useState)("");
    const siteName = (0,react.useRef)(null);
    const { name ="" , desc ="" , sku ="" , category ="" , slug ="" , image ="" , color ="" , quantity =0 , currencySign ="$" , totalPrice =0 , unitPrice =0 , discountedPrice =0 , noShipping =false , outOfStock =false  } = data;
    const productName = name ? "".concat(name, " ").concat(!pdpView ? desc : "") : desc;
    (0,react.useEffect)(()=>{
        if (category && slug && sku) {
            (0,helper/* getPDPUrl */.ir5)(category, slug).then((pdpUrl)=>{
                const param = sku ? "skuId=".concat(sku) : "";
                const redirectUrl = (0,utils/* getPdpRedirectUrl */.Om)(pdpUrl, param);
                setProductPdpUrl(redirectUrl);
            });
        }
    }, [
        category,
        slug,
        sku
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            siteName.current = get_default()(config, "general.siteName", "");
        });
    }, []);
    const customerFacingSKUId = data.customerFacingSKU || data.sku;
    const cartItemProductInfo = JSON.stringify({
        productInfo: {
            productBrand: (ref = siteName.current) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: (0,helper/* sanitizeTextForAnalytics */.T68)(data.desc),
            globalPromotionPrice: Number(data.discountedPrice) ? Number(data.discountedPrice) : Number(data.unitPrice),
            priceState: data.discountPercent > 0 ? "percentOff|" + data.discountPercent : "regular price",
            productBasePrice: Number(data.unitPrice),
            productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(data.color) || "n/a",
            productID: customerFacingSKUId,
            productName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productSalePrice: Number(data.discountedPrice) ? Number(data.discountedPrice) : Number(data.unitPrice),
            productStatus: data.outOfStock && data.availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: data.superSku ? true : false,
            productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            quantity: data.quantity,
            defaultImageName: data.image,
            productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.productCollectionsName || data.category),
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "true",
            productSaleable: "true",
            isRecommended: "true",
            isSendNow: "true",
            isSubscription: "true",
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: "bundle",
            productFindingMethod: "n/a"
        }
    });
    const productPrice = discountedPrice ? discountedPrice : unitPrice;
    const handleProductClickAnalytics = ()=>{
        const eventInfo = (0,cartAnalytics/* addCartItemSummaryAnalytics */.Jk)(page, data.desc, data.name, productPdpUrl, true);
        (0,analytics/* cartItemSummaryAnalytics */.$y)(eventInfo, cartItemProductInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).ChildItems,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: productPdpUrl,
                    onClick: handleProductClickAnalytics,
                    className: "gbh-data-layer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image,
                        alt: productName,
                        fill: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "information-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: productPdpUrl,
                        className: "list-title",
                        onClick: handleProductClickAnalytics,
                        children: productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "attributes",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    colorOrFinish,
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "attributes-details",
                                        children: color
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    qty,
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "attributes-details",
                                        children: quantity
                                    }),
                                    pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "price-group mobile",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: unitPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "linethrough",
                                                children: [
                                                    currencySign,
                                                    unitPrice
                                                ]
                                            }) : null
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "preview-cart-bundle-price",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "price-divider",
                                                children: "/"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: totalPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    noShipping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cart-item__stock-msg --error",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: cannotShipLabel
                        })
                    }) : null,
                    outOfStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "error",
                        children: outOfStockLabel
                    }) : null
                ]
            }),
            pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "price-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "price",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: productPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        })
                    }),
                    discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "linethrough",
                        children: [
                            currencySign,
                            unitPrice
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var BundlesViewDetails_BundleChildItems = (BundleChildItems);

// EXTERNAL MODULE: ./components/Bundles/StaticBundle/index.module.scss
var StaticBundle_index_module = __webpack_require__(58177);
var StaticBundle_index_module_default = /*#__PURE__*/__webpack_require__.n(StaticBundle_index_module);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/index.jsx







const StaticBundle = (props)=>{
    const { isViewBundle ="" , pdpView , data , page =""  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { productPrice =0 , currencySign ="" , // listPrice = 0,
    lineItem =[]  } = data;
    const { includedPdpItemsLabel , subTotalItems =()=>{}  } = staticText;
    // const percentOff = 100 - Math.round((productPrice / listPrice) * 100)
    const totalItems = lineItem.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StaticBundle_index_module_default()).BundleSectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bundles ".concat(isViewBundle ? "preview-cart-bundles" : "fade-out"),
            children: [
                pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "include-item",
                    children: includedPdpItemsLabel
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lists ".concat(pdpView ? "pdp-bundle-lists" : ""),
                    children: lineItem.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesViewDetails_BundleChildItems, {
                                data: item,
                                pdpView: pdpView,
                                page: page
                            })
                        }, item.id))
                }),
                pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bundles-bottom-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "price-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subtotal",
                                children: subTotalItems(totalItems)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "bundles-total-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: productPrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Bundles_StaticBundle = (StaticBundle);


/***/ }),

/***/ 34252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ viewDetailsBundleAnalytics; },
/* harmony export */   "UQ": function() { return /* binding */ accordianClickBundleFeature; },
/* harmony export */   "V8": function() { return /* binding */ viewMoreBundleFeature; },
/* harmony export */   "si": function() { return /* binding */ addAnlyticsForSDownloadSpec; }
/* harmony export */ });
const viewDetailsBundleAnalytics = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const eventInfo = {
        eventAction: "cart preview:view details:".concat(title),
        eventName: "cart preview:view details:".concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view details:".concat(title),
        internalLinkPosition: "cart:bundle",
        internalLinkType: "cart:view details",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo ? productInfo.productInfo : "");
};
const addAnlyticsForSDownloadSpec = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedFileList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], techFils = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const techFilsLists = techFils.map((selectedObj)=>selectedObj.toLowerCase());
    const eventInfo = {
        eventAction: "pdp:".concat(mainTitle, ":").concat(title),
        eventName: "pdp:".concat(mainTitle, ":").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "".concat(title, "|").concat(selectedFileList.join(":").toLowerCase()),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(mainTitle, ":").concat(title),
        internalLinkZoneName: "pdp:".concat(mainTitle),
        internalLinkURL: techFilsLists.join(":"),
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const viewMoreBundleFeature = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        eventAction: "pdp:specs:view more",
        eventName: "pdp:specs:view more",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view more",
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:specs:view more",
        internalLinkZoneName: "pdp:specs",
        internalLinkURL: "".concat(window.location.origin).concat(url),
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const accordianClickBundleFeature = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", accordianState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        eventAction: "pdp:product details:filters ".concat(accordianState),
        eventName: "pdp:product details:filters ".concat(accordianState),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: accordianState,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 60303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        viewDetails: t("kf.pdp.bundles.viewDetails"),
        includedItemsLabel: t("kf.pdp.bundles.includedItems"),
        colorOrFinish: t("kf.pdp.label.colorOrFinish"),
        qty: t("kf.checkout.label.qtyLabel"),
        subTotal: t("kf.pdp.label.subTotal"),
        subTotalItems: (number)=>t("kf.pdp.bundles.subTotalItems", {
                number
            }),
        saveOnBundle: (number)=>t("kf.pdp.bundles.saveOnBundle", {
                number
            }),
        includedItemsQty: (number)=>t("kf.pdp.bundles.includedItemsQty", {
                number
            }),
        includesItemsQty: (number)=>t("kf.pdp.bundles.includesItemsQty", {
                number
            }),
        featuresLabel: t("kf.pdp.label.features"),
        specsInstallationLabel: t("kf.pdp.bundles.specsInstallation"),
        dimensionsLabel: t("kf.pdp.bundles.dimensions"),
        viewMoreLabel: t("kf.pdp.label.viewMore"),
        downloadAllSpecSheetsLabel: t("kf.pdp.bundles.downloadAllSpecSheets"),
        downloadAllInstallGuidesLabel: t("kf.pdp.bundles.downloadAllInstallGuides"),
        cannotShipLabel: t("kf.cart.label.cannotShip"),
        includedPdpItemsLabel: t("kf.pdp.bundles.includedPdpItemsLabel"),
        outOfStockLabel: t("kf.cart.label.outOfStock"),
        outOfStockText: t("kf.pdp.bundles.outOfStock"),
        outOfStockAlert: t("kf.pdp.bundles.alert.outOfStock"),
        quickViewLabel: t("kf.button.quickView"),
        addToCartLabel: t("kf.global.label.addCart"),
        addToCartNote: t("kf.pdp.bundles.addToCartNote"),
        currentPriceAriaLabel: t("kf.pdp.label.currentPrice")
    };
};


/***/ }),

/***/ 69162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ cartItemSummaryAnalytics; },
/* harmony export */   "D_": function() { return /* binding */ getTrackingLinkAnalyticsData; },
/* harmony export */   "Xh": function() { return /* binding */ cartBundleFinishAnalytics; }
/* harmony export */ });
/* harmony import */ var _components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54114);
/* harmony import */ var _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6055);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20558);




const getTrackingLinkAnalyticsData = function(link, analyticsData) {
    let isTabsEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, activeTab = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const tabName = (0,_components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_0__/* .getFormattedTabNameForAnalytics */ .oH)(activeTab);
    return analyticsData ? JSON.stringify({
        eventAction: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        eventName: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        internalLinkPosition: isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION */ .mu : "order history",
        internalLinkType: isTabsEnabled ? "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(tabName) : "my account:navigation",
        internalLinkZoneName: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK).concat(isTabsEnabled ? ":".concat(tabName) : ""),
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    }) : null;
};
const cartItemSummaryAnalytics = (analyticTitleData, productInfoData)=>{
    const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {};
    const productInfo = productInfoData ? JSON.parse(productInfoData) : {};
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click", {}, productInfo);
};
const cartBundleFinishAnalytics = function() {
    let bundleLocalStorage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", payloadData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const bundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    if (bundleItems.length) {
        const selctedBundle = bundleItems.find((bItem)=>{
            var ref;
            return Array.isArray(bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus) && (bItem === null || bItem === void 0 ? void 0 : (ref = bItem.selectedSkus) === null || ref === void 0 ? void 0 : ref.includes(payloadData === null || payloadData === void 0 ? void 0 : payloadData.sku));
        });
        if (selctedBundle && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .isObjectEmpty */ .nK)(selctedBundle)) {
            const updatedBundleItems = bundleItems.map((bItem)=>{
                if (bItem.bundleId === selctedBundle.bundleId) {
                    const selectedSkus = bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus.filter((sku)=>{
                        return sku !== (payloadData === null || payloadData === void 0 ? void 0 : payloadData.sku);
                    });
                    return {
                        ...bItem,
                        selectedSkus
                    };
                }
                return bItem;
            });
            localStorage.setItem("bundleItems", JSON.stringify(updatedBundleItems));
        }
    }
};


/***/ }),

/***/ 5777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChildItems":"BundleChildItems_ChildItems__zonWx"};

/***/ }),

/***/ 58177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundleSectionWrapper":"StaticBundle_BundleSectionWrapper__yPZzX","fadeInOpacity":"StaticBundle_fadeInOpacity__oONw0"};

/***/ })

}]);